const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar teléfono",
        quickMessages: "Respuestas Rápidas",
        phonecopied: "Teléfono copiado al portapapeles.",
        noPhone: "No hay teléfono disponible para copiar",
        copyError: "Error al copiar el teléfono",
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Sesiones hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidos",
          totalSentMessages: "Total de Mensajes Enviados",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de sesiones",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponible hasta",
        },
        assessments: {
          totalCalls: "Total de Sesiones",
          callsWaitRating: "Sesiones aguardando evaluación",
          callsWithoutRating: "Sesión sin evaluación",
          ratedCalls: "Sesiones evaluadas",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Detractores",
        },
      },
      reports: {
        title: "Reporte de Encuestas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Reportes",
        calls: "Atenciones",
        search: "Búsquedas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Sesión",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Departamento",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
          valorVenda: "Valor de la Venta",
          motivoNaoVenda: "Motivo de No Venta",
          finalizadoComVenda: "Finalizado con Venta",
          accessTicket: "Aceder a Sesión",
          logTicket: "Logs de la Sesión",
          yes: "Si",
          no: "No",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando reporte compactado, por favor espere.",
          errorToast: "Error al generar reporte",
          back: "Volver",
          groupServiceReport: "Reporte de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Última Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidad",
          percentage: "porcentaje",
          title: "Reporte de Encuestas Realizadas",
          activeSearch: "Encuesta activa",
          inactiveSearch: "Encuesta inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando reporte compactado, por favor espere.",
          title: "Reporte de Duración de la Atención",
          startService: "Inicio de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Reporte de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando reporte compactado, por favor espere.",
          title: "Reporte de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Departamento",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
            valorVenda: "Valor de la Venta",
            motivoNaoVenda: "Motivo de No Venta",
            finalizadoComVenda: "Finalizado con Venta",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted: "¡La conexión de WhatsApp ha sido eliminada correctamente!",
          closedimported: "Estamos cerrando las sesiones importadas, por favor espera.",
          loadError: "No se pudo cargar la lista de empresas",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar sesiones importadas",
          closedImportedMessage:
            "¿Seguro? Todas las sesiones importadas serán cerradas.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todas las sesiones Importadas",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          color: "Color",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay una sesión abierta para este contacto:",
          user: "Agente",
          queue: "Departamento",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historial",
        },
        options: {
          create: "Sesión creada.",
          chatBot: "ChatBot iniciado.",
          queue: " - Departamento definida.",
          open: "inició la atención.",
          access: "accedió a la sesión.",
          transfered: "transfirió la sesión.",
          receivedTransfer: "recibió la sesión transferida.",
          pending: "regresó a la Departamento.",
          closed: "cerró la sesión",
          reopen: "abrió la sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar sesiones tras importación",
          queueIdImportMessages: "Departamento para mensajes importados",
          name: "Nombre",
          queueRedirection: "Redirección de departamento",
          queueRedirectionDesc:
            "Seleccione un departamento al que se redirigirán los contactos que no tienen departamento asignado.",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Espera (min)",
          importAlert:
            "ATENCIÓN: Al guardar, la conexión se cerrará y tendrás que volver a leer el código QR para importar los mensajes.",
          groupAsTicket: "Grupos como Sesión",
          showGroupNotification: "Notificar mensajes de grupo",
          timeCreateNewTicket: "Nuevo ticket (min)",
          maxUseBotQueues: "Envíos chatbot (máx)",
          timeUseBotQueues: "Ciclo chatbot (min)",
          timeToReturnQueue: "Retorno depto. (min)",
          expiresTicket: "Expirar chats (h)",
          expiresTicketNPS: "Expirar NPS (min)",
          maxUseBotQueuesNPS: "Envíos NPS (máx)",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          collectiveVacationStart: "Inicio de vacaciones",
          collectiveVacationEnd: "Fin de vacaciones",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ocultar mensaje borrado por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación (0-10)",
          token: "Token para integración externa",
          sendIdQueue: "Departamento",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage: "Inactividad (min)",
          flowInactiveTime: "Flujo inact. (min)",
          maxUseInactiveTime: "Máx. avisos inact.",
          flowIdInactiveTime: "Flujo de inactividad",
          whenExpiresTicket: "Cerrar por msg. de",
          expiresInactiveMessage: "Mensaje al cerrar por inactividad",
          prompt: "Prompt",
          triggerIntegrationOnClose: "Activar integración al cerrar sesión",
          enableIntegration: "Activadores Integración",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          business_id: "Business ID",
          phone_number: "Número de teléfono",
          send_token: "Token de envío",
          isOficial: "WhatsApp Oficial",
          flowAwaitActiveFlow: "Tiempo espera flujo activo (min)",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccionar una Departamento para redireccionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          bulkDeleted: "{{count}} contactos eliminados satisfactoriamente",
          allDeleted: "Todos los {{count}} contactos fueron eliminados",
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "Flujos de conversación",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todas las sesiones relacionadas se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
          wallet: "Cartera",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historial",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Departamento/Departamento",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          lidHelper: "Identificador del dispositivo vinculado",
          birthDate: "Fecha de nacimiento",
          birthDateHelper: "Se usa para enviar mensajes automáticos de cumpleaños",
          assignWallet: "Asignar responsable",
          whatsapp: "WhatsApp asignado:",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar sesiones sin Departamento",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene Departamentos asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Departamento",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Departamento",
        selectUserAndQueue: "Seleccione un usuario y una Departamento",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
      },
      queueModal: {
        title: {
          queueData: "General",
          text: "Horarios de atención",
          add: "Agregar Departamento",
          edit: "Editar Departamento",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la Departamento (Bot)",
          rotate: "Rotativo",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar sesión al finalizar",
          timeRotate: "Tiempo de rotación",
          typeRandomMode: "Tipo de distribución",
          randomizeImmediate: "Asignar inmediatamente al siguiente agente",
          queueType: "Tipo de menú",
          message: "Mensaje de respuesta",
          queue: "Departamento para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Departamento",
          integration: "Integración",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Departamento",
          selectIntegration: "Seleccione una Integración",
          addOptions: "Agregar opción de menú",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QR Code.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Eliminar Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión por defecto",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin Departamento",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menú Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historiales",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar sesiones pendientes",
          showDashboard: "Ver Dashboard",
        },
        google: {
          title: "Acceso con Google",
          description: "Vincula tu cuenta de Google para poder entrar también con tu Gmail personal, sin dejar de usar tu correo interno.",
          linkButton: "Vincular con Google",
          linkedTitle: "Cuenta de Google vinculada",
          linkedHint: "Puedes entrar con cualquiera de los dos correos, misma contraseña.",
          unlink: "Desvincular",
          unlinkConfirmTitle: "Desvincular cuenta de Google",
          unlinkConfirmBody: "Confirma tu contraseña actual para quitar el acceso con Google.",
          currentPassword: "Contraseña actual",
          currentPasswordRequired: "Ingresa tu contraseña actual",
          linkedSuccess: "Cuenta de Google vinculada correctamente",
          unlinkedSuccess: "Cuenta de Google desvinculada",
          unlinkError: "No se pudo desvincular la cuenta",
        },
        tabs: {
          general: "General",
          permissions: "Permisos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          assinar: "Firmar mensaje",
          reminderDate: "Fecha de Recordatorio",
          reminderInfo: "El mensaje del recordatorio será igual al mensaje programado.",
          reminderDesc: "Define una fecha de recordatorio. El mensaje se enviará en esa fecha en lugar de la fecha original.",
          reminderTitle: "Recordatorio (Opcional)",
          quickMessagePlaceholder: "Busca respuestas rápidas...",
          quickMessageNotFound: "No se encontraron respuestas rápidas",
          quickMessageChip: "De Respuesta Rápida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar archivo adjunto",
          deleteMessage: "¿Deseas eliminar este archivo adjunto?",
        },
        toasts: {
          deleted: "Archivo adjunto eliminado satisfactoriamente.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
          addKanban: "Nueva columna",
          backToKanban: "Volver al Kanban",
          editKanban: "Editar Etapa",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo máximo en esta etapa (horas, 0 = sin límite)",
          nextLaneId: "Mover a esta etapa después del tiempo",
          greetingMessageLane: "Mensaje automático al entrar a esta etapa",
          mediaFiles: "Archivos que se envían al entrar",
          rollbackLaneId: "Etapa de retroceso si no hay respuesta",
          uploadHint: "Haz clic para adjuntar archivos (Imagen, PDF, Audio, Video)",
          uploadMaxSize: "Tamaño máximo: 10MB por archivo",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        toasts: {
          fileTooLarge: "El archivo {{name}} es demasiado grande. Máximo: 10MB",
          fileTypeNotSupported: "El tipo de archivo {{type}} no es compatible",
        },
        errors: {
          tooShort: "Nombre demasiado corto",
          required: "Obligatorio",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Nuevo archivo",
          edit: "Editar archivo",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Descripción",
          options: "Archivos adjuntos",
          extraName: "Nombre del archivo",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona una sesión para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todas las sesiones?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nueva",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nueva",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      tickets: {
        messageHidden: "Mensaje oculto",
        inbox: {
          closedAllTickets: "¿Cerrar todas las sesiones?",
          closedAllTicketsWarning: "Esta acción finalizará todas las conversaciones activas.",
          closedAll: "Cerrar Todas",
          newTicket: "Nueva Sesión",
          yes: "Sí, cerrar",
          no: "NO",
          open: "Abiertas",
          resolverd: "Resueltas",
        },
        toasts: {
          deleted: "La sesión en la que estabas ha sido eliminada.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltas" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar sesiones y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Sesiones por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Departamento",
          scredule: "Programar",
          deleteTicket: "Borrar Sesión",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Sesión",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Departamento",
        fieldQueuePlaceholder: "Seleccione un Departamento",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Sesiones",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
          "No se encontraron sesiones con este estado o término de búsqueda",
        noQueue: "Sin Departamento",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar a PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar departamento",
        },
      },
      newTicketModal: {
        title: "Crear Sesión",
        fieldLabel: "Escribe para buscar un contacto",
        fieldQueuePlaceholder: "Selecciona un departamento",
        fieldQueueRequired: "Debes seleccionar un departamento",
        fieldConnectionPlaceholder: "Selecciona una conexión",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Departamentos",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          ratings: "Reporte de Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programación",
          campaigns: "Campañas",
          annoucements: "Comunicados",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Admin conexiones",
          files: "Lista de archivos",
          birthdaySettings: "Config. Cumpleaños",
          reports: "Reportes",
          management: "Gerencia",
          callHistorical: "Historial de Llamadas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Ubicación",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Actualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        toasts: {
          success: "Mensaje enviado con éxito",
        },
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Departamento",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes con Archivos",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Número",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensajes con Archivos",
            instructions:
              "A continuación se muestra la información necesaria para enviar mensajes con archivos adjuntos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
        messageHidden: "Mensaje oculto",
      },
      triggerFlowModal: {
        title: "Activar Flujo",
        description: 'Selecciona un flujo para ejecutar en este ticket. El ticket cambiará a estado \'chatbot\' durante la ejecución.',
        selectFlow: "Elige un flujo",
        selectedFlow: "Flujo seleccionado",
        flowId: "ID del flujo",
        noFlows: "No se encontró ningún flujo activo",
        cancel: "Cancelar",
        trigger: "Activar Flujo",
        triggering: "Activando...",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo eliminado satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
          attachMedia: "Adjuntar Multimedia",
          newFile: "Nuevo Archivo",
          newAudio: "Nuevo Audio",
          newAudioRecorded: "Audio grabado",
          chooseMedia: "Elige una opción para adjuntar multimedia:",
          chooseNewMedia: "Elige un nuevo archivo para reemplazar:",
          attachFile: "Adjuntar Archivo",
          recordAudio: "Grabar Audio",
          cancelEdit: "Cancelar Edición",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contactos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Estado",
          scheduledAt: "Programación",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programación",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Estado de la Sesión",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir sesión",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          stopRecurrence: "Recurrencia detenida satisfactoriamente",
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro eliminado",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Departamentos",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la Departamento (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar Departamento",
        },
        toasts: {
          success: "Departamento guardada",
          deleted: "Departamento eliminada",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Las sesiones en esa Departamento seguirán existiendo, pero ya no tendrán ninguna Departamento asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Departamentos",
        inputLabelRO: "Departamentos solo para lectura",
        withoutQueue: "Sin Departamento",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Última actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las Departamentos y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Estado",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final del trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Las sesiones abiertas de los usuarios se moverán a la Departamento.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Departamentos",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Sí",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurrencia",
          generateInvoice: "Generar Factura",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa eliminada satisfactoriamente.",
          success: "Operación realizada con éxito",
          loadError: "No se pudo cargar la lista de empresas",
          saveError: "No se pudo guardar. Verifica que no exista otra empresa con el mismo nombre o que los campos estén correctos.",
          deleteError: "No se pudo eliminar la empresa",
        },
        confirmationModal: {
          deleteTitle: "Eliminar empresa",
          deleteMessage: "¿Deseas eliminar esta empresa? Toda su información será eliminada.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Departamentos",
          maxKanbanBoards: "Tableros Kanban",
          amount: "Valor",
          campaigns: "Campañas",
          schedules: "Programas",
          internalChat: "Chat interno",
          externalApi: "API externa",
          integrations: "Integraciones",
          trial: "Trial",
          trialDays: "Días de prueba",
          public: "Público",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Sí",
          no: "No",
          money: "MXN",
        },
        toasts: {
          success: "Operación realizada con éxito",
          loadError: "No se pudo cargar la lista de planes",
          saveError: "No se pudo guardar. Verifica que no exista otro plan con el mismo nombre o que los campos estén correctos.",
          deleteError: "No se pudo realizar la operación",
        },
        confirmationModal: {
          deleteTitle: "Eliminar plan",
          deleteMessage: "¿Deseas eliminar este plan?",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      birthday: {
        title: "Configuración de Cumpleaños",
        preview: "Vista previa:",
        save: "Guardar configuración",
        saving: "Guardando...",
        sections: {
          users: "Cumpleaños de Usuarios",
          contacts: "Cumpleaños de Contactos",
          general: "Configuración General",
        },
        users: {
          enable: "Habilitar notificaciones de cumpleaños de usuarios",
          enableHelper: "Cuando está habilitado, se muestra un modal de felicitaciones y se crea un aviso automático",
          announcement: "Crear aviso automático para cumpleaños de usuarios",
          announcementHelper: "Crea un aviso automático que se muestra a todos los usuarios de la empresa",
          messageLabel: "Mensaje de cumpleaños para usuarios",
          messageHelper: "Usa {nombre} para incluir el nombre del usuario",
        },
        contacts: {
          enable: "Habilitar envío automático de mensajes de cumpleaños a contactos",
          enableHelper: "Envía automáticamente un mensaje de felicitaciones por WhatsApp a los contactos que cumplen años",
          messageLabel: "Mensaje de cumpleaños para contactos",
          messageHelper: "Usa {nombre} para el nombre del contacto y {edad} para la edad",
          testButton: "Probar mensaje",
        },
        general: {
          sendTime: "Hora de envío de mensajes",
          sendTimeHelper: "Hora a la que se enviarán los mensajes automáticos",
          whatsappConnection: "Conexión WhatsApp para envío",
          selectConnection: "Selecciona una conexión",
          connectionHelper: "Conexión WhatsApp que se usará para enviar los mensajes de cumpleaños",
          internalAnnouncement: "Crear aviso interno para cumpleaños de usuarios",
          internalAnnouncementHelper: "Crea un aviso interno cuando un usuario cumple años",
          variables: "Variables disponibles en los mensajes:",
          variableName: "— Nombre de la persona",
          variableAge: "— Edad de la persona (solo para contactos)",
        },
        toasts: {
          loadError: "Error al cargar la configuración de cumpleaños",
          saveSuccess: "Configuración de cumpleaños guardada con éxito",
          saveError: "Error al guardar la configuración",
          testSuccess: "Mensaje de prueba enviado",
          testError: "Error al enviar el mensaje de prueba",
          testPrompt: "Ingresa el ID de un contacto para la prueba:",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres eliminar esta programación?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres eliminar esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Etapas del Kanban",
        subtitle: "Cada etapa es una columna del tablero. Puedes configurar mensajes automáticos, archivos y tiempos de permanencia.",
        laneDefault: "Abierto(s)",
        backToKanban: "Volver al Kanban",
        confirmationModal: {
          deleteTitle: "¿Eliminar esta etapa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Sesiones",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva columna",
        },
        toasts: {
          deleted: "Etapa eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Archivos de respuesta rápida",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          schedules: "Horarios",
          finalizacaoAtendimento: "Cierre de Atención",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
          whitelabel: "Whitelabel",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Departamento",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar la sesión",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de Departamento/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una Departamento",
            sendQueuePosition: "Enviar mensaje con la posición en la Departamento",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar la sesión",
            closeTicketOnTransfer: "Cerrar sesión al transferir a otra Departamento",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para sesiones pendientes",
            copyContactPrefix: "Prefijo al copiar contacto",
            copyContactPrefixPlaceholder: "Ej: mx",
          },
          sections: {
            copyContactPrefix: "Prefijo para copia de contactos",
            paymentEfi: "Pagos Efí (GerenciaNet)",
            paymentMP: "Mercado Pago",
            paymentStripe: "Stripe",
            paymentAsaas: "ASAAS",
            customMessages: "Mensajes personalizados",
            updated: "Configuración actualizada con éxito",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la Departamento",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar la sesión",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = Departamento de destino",
          },
          LGPD: {
            title: "Política de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrado",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de teléfono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
        finalizacaoAtendimento: {
          title: "Cierre de Atención",
          generalSettings: "Configuración general",
          informSaleValue: "Registrar valor de la venta al cerrar la atención",
          informSaleValueHelper: "Cuando está habilitado, el campo de valor de venta aparece en el modal de cierre",
          closingReasons: "Motivos de cierre",
          addReason: "Agregar motivo",
          noReasons: "Sin motivos registrados. Haz clic en \"Agregar motivo\" para comenzar.",
          table: {
            name: "Nombre",
            description: "Descripción",
            actions: "Acciones",
            noDescription: "Sin descripción",
          },
          modal: {
            addTitle: "Agregar motivo",
            editTitle: "Editar motivo",
            nameLabel: "Nombre del motivo",
            descriptionLabel: "Descripción (opcional)",
          },
          buttons: {
            cancel: "Cancelar",
            save: "Guardar",
            saving: "Guardando...",
            update: "Actualizar",
          },
          toasts: {
            updated: "Motivo actualizado con éxito",
            created: "Motivo creado con éxito",
            deleted: "Motivo eliminado con éxito",
            errorSave: "Error al guardar el motivo",
            errorDelete: "Error al eliminar el motivo",
            deleteConfirm: "¿Eliminar este motivo de cierre?",
            settingUpdated: "Configuración actualizada con éxito",
            nameRequired: "El nombre del motivo es obligatorio",
          },
        },
        toasts: {
          schedulesUpdated: "Horarios actualizados con éxito",
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            logTicket: "Logs de la Sesión",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar la sesión.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage: "",
        placeholderOpen: "",
        placeholderClosed: "",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privado",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
        toasts: {
          fileExported: "Archivo \"{{fileName}}\" exportado satisfactoriamente!",
          blocked: "Contacto bloqueado",
          unblocked: "Contacto desbloqueado",
        },
        errors: {
          possibleLidNumber: "Posible error: el número parece ser un LID",
        },
        searchPlaceholder: "Buscar en los mensajes...",
        technicalDetails: "Detalles técnicos",
        lastInteraction: "Última interacción",
        totalTickets: "Tickets totales",
        ticketHistory: "Historial de tickets",
        noTicketHistory: "Sin tickets anteriores",
        noTagsAvailable: "No hay etiquetas disponibles",
      },
      relatorioVendas: {
        title: "Reporte de Ventas",
        selectPeriod: "Por favor, seleccione el periodo",
        dateFrom: "Fecha Inicial",
        dateTo: "Fecha Final",
        attendant: "Agente",
        all: "Todos",
        generating: "Generando...",
        generate: "Generar Reporte",
        motivoNaoVenda: "Motivo de No Venta",
        motivoFinalizacao: "Motivo de Finalización",
        totalVendas: "Total de Ventas",
        totalValorVendas: "Valor Total de Ventas",
        naoVendas: "No Ventas",
        mediaTicketPorAtendente: "Promedio de Sesiones por Agente",
        ticketsFinalizados: "Sesiones Finalizadas",
        id: "ID",
        date: "Fecha",
        valorVenda: "Valor de la Venta",
        desempenhoPorAtendente: "Desempeño por Agente",
        totalTickets: "Total de Sesiones",
        mediaTicket: "Promedio de Sesiones",
      },
      kanbanCard: {
        ticketNumber: "Sesión nº",
        value: "Valor:",
        assignValue: "Asignar Valor",
        remove: "Eliminar",
        viewTicket: "Ver Sesión",
        editValue: "Editar Valor de la Oportunidad",
        assignOpportunityValue: "Asignar Valor de la Oportunidad",
        opportunityValue: "Valor de la Oportunidad",
        save: "Guardar",
        cancel: "Cancelar",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº de la Sesión",
          queue: "Departamento",
          connection: "Conexión",
          scheduledDate: "Fecha programada",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar sesión #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes relacionados con la sesión se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          richText: {
            bold: "Negrita",
            italic: "Itálica",
            strikethrough: "Tachado",
            code: "Código",
            numberedList: "Lista Numerada",
            bulletedList: "Lista con Viñetas",
            quote: "Cita",
            clearFormatting: "Limpiar Formato",
          },
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        title: "Facturas",
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Departamentos",
          queues: "Departamentos",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          dueDate: "Vencimiento",
          status: "Estado",
          action: "Acción",
        },
        status: {
          paid: "Pagado",
          overdue: "Vencido",
          open: "Pendiente",
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGADO",
        },
        expiredAlert: {
          attention: "Atención",
          message: "Tu suscripción está vencida. Contacta con soporte para regularizar tu situación.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay una sesión abierta para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ninguna sesión con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear la sesión en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhatsApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una Departamento.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID del Departamento o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar la sesión - true/false',
        fieldMedia: '"medias": archivo adjunto',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar la sesión - true/false",
        formData: "FormData:",
        headerAuthorizationMultipart:
          "Authorization Bearer (token registrado) y Content-Type (multipart/form-data)",
        testSend: "Probar envío",
      },
      recurrenceSection: {
        title: "Recurrencia",
        description:
          "Puedes enviar el mensaje de forma recurrente y elegir el intervalo. Si es un mensaje único, no cambies nada en esta sección.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Departamentos",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "Sin Departamento",
        accessTicket: "Ver sesión",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
        deletedSuccess: "Campaña eliminada con éxito",
        updatedSuccess: "¡Campaña actualizada con éxito!",
        createdSuccess: "¡Campaña creada con éxito!",
        nameNotDefined: "Nombre no definido",
        phraseRequired: "La frase es obligatoria",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID de la Sesión",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Nombre del Grupo",
          create: "Crear",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
      common: {
        errors: {
          noCompanyPermission: "Esta empresa no tiene permiso para acceder a esta página. Te estamos redirigiendo.",
        },
        table: {
          rowsPerPage: "Filas por página:",
        },
      },
      flowBuilderRemoveTagModal: {
        title: {
          create: "Eliminar una etiqueta del flujo",
          edit: "Editar eliminación de etiqueta",
        },
        chooseTag: "Elige una etiqueta para eliminar del contacto",
        actionDescription: "Esta acción eliminará la etiqueta seleccionada del contacto cuando se ejecute el flujo",
      },
      documentModal: {
        fileTypes: {
          pdf: "Documento PDF",
          doc: "Documento Word",
          docx: "Documento Word",
          odt: "Documento OpenDocument",
          xls: "Hoja de cálculo Excel",
          xlsx: "Hoja de cálculo Excel",
          ods: "Hoja de cálculo OpenDocument",
          ppt: "Presentación PowerPoint",
          pptx: "Presentación PowerPoint",
          odp: "Presentación OpenDocument",
          zip: "Archivo Comprimido",
          rar: "Archivo Comprimido",
          "7z": "Archivo Comprimido",
          tar: "Archivo Comprimido",
          gz: "Archivo Comprimido",
          bz2: "Archivo Comprimido",
          xml: "Archivo XML",
          json: "Archivo JSON",
          html: "Archivo HTML",
          ofx: "Archivo OFX",
          msg: "Correo de Outlook",
          key: "Presentación Keynote",
          numbers: "Hoja de cálculo Numbers",
          pages: "Documento Pages",
          exe: "Ejecutable",
          ret: "Archivo RET",
          default: "Documento",
        },
      },
      contactDeleteConfirmModal: {
        titleAll: "¿Eliminar TODOS los {{totalCount}} contactos?",
        titleSelected: "¿Eliminar {{selectedCount}} contactos seleccionados?",
        warningAll: "⚠️ ATENCIÓN: ¡Esta acción eliminará TODOS los {{totalCount}} contactos de la empresa permanentemente!",
        bodyAll: "Esta operación no se puede deshacer. Todos los contactos, sus historiales de mensajes, etiquetas y relaciones se perderán definitivamente.",
        warningSelected: "Esta acción eliminará {{selectedCount}} contactos seleccionados permanentemente.",
        bodySelected: "Los contactos seleccionados y sus datos relacionados serán eliminados definitivamente.",
      },
      avatarUpload: {
        errors: {
          unsupportedFormat: "Formato de archivo no soportado. Usa solo JPG, PNG, GIF o WebP.",
        },
      },
      pdfViewer: {
        errors: {
          downloadNotFound: "Error: No es posible descargar, URL no encontrada",
        },
      },
      whatsappCloudApiTest: {
        toasts: {
          sent: "Mensaje enviado con éxito.",
        },
      },
      sgp: {
        options: {
          yes: "SÍ",
          no: "NO",
        },
        integrationTypes: {
          none: "Ninguna",
          secondCopyInvoice: "2ª Vía de Factura",
          dueDate: "Por Vencer",
          overdue: "Vencido",
          confidenceRelease: "Liberación por Confianza",
        },
        errors: {
          nameRequired: "El nombre de la integración es obligatorio.",
          urlRequired: "SGP URL es obligatorio.",
        },
      },
      flowDefault: {
        confirmationModal: {
          deleteMessage: "¿Estás seguro que deseas eliminar este flujo? Todas las integraciones relacionadas se perderán.",
        },
      },
      flowBuilder: {
        validation: {
          keywordRequired: "Se requiere al menos una palabra clave en modo temporal",
          voiceKeyRequired: "Voice Key es obligatoria para síntesis de voz",
          voiceRegionRequired: "Voice Region es obligatoria para síntesis de voz",
        },
        placeholder: {
          aiInstructions: "Describe cómo debe comportarse la IA, qué información debe recolectar, cómo debe responder...",
          keywordExample: "Ej: Recolectar datos del cliente, Calificar interés, Diagnosticar problema...",
          azureSpeechKey: "Clave del Azure Speech Service",
        },
      },
      ticketsCustom: {
        toasts: {
          finished: "¡Sesión finalizada con éxito!",
        },
      },
      contactImport: {
        invalidFile: "¡Archivo inválido!",
        ignoredWarning: "⚠️ {{countIgnored}} contactos ignorados (número inválido o no marcados para actualizar)",
      },
    },
  },
};

export { messages };
